import React from 'react'

import './tagcard.css'
import { contentfulImageSrcSet, contentfulImageUrl } from '../lib/contentful-image'

const TagCard = data => (
    <div className='TagCard'>
        <div className='TagCard-img-container'>
            <img
                src={contentfulImageUrl(data.logo, 320)}
                srcSet={contentfulImageSrcSet(data.logo, [160, 320, 480])}
                sizes="(max-width: 640px) 30vw, 180px"
                draggable="false"
                loading="lazy"
                decoding="async"
                alt=""
            />
        </div>
        <div className='Text'>
            <h1>#{data.name}</h1>
            <p>{data.description}</p>
        </div>
    </div>
)

export default TagCard
